import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@kareo/design-system';
import CardActionArea from '@material-ui/core/CardActionArea';
import { CardTypes, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import Loader from 'shared-assets/components/Loader';
import rollbar from 'shared-assets/src/errors/errors';
import CardContentContainer from 'shared-assets/facesheet-ui/components/Facesheet/Card/CardContentContainer';
import { FacesheetStyledCard, FacesheetCardTitle, FacesheetCardContent, } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import CardContentError from 'shared-assets/facesheet-ui/components/Facesheet/Error/CardContentError';
import { ErrorBoundary } from 'react-error-boundary';
var FacesheetCard = function (_a) {
    var patientId = _a.patientId, title = _a.title, url = _a.url, fetchCardData = _a.fetchCardData, patientStatus = _a.patientStatus;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), cardData = _c[0], setCardData = _c[1];
    var _d = useState(false), inError = _d[0], setInError = _d[1];
    var _e = useState(false), isEmpty = _e[0], setIsEmpty = _e[1];
    useEffect(function () {
        if (patientId && patientId > 0) {
            loadCardData();
        }
    }, [patientId]);
    var loadCardData = function () {
        fetchCardData(patientId)
            .then(function (data) {
            setCardData(data);
            setIsEmpty(data.length <= 0);
        })
            .catch(function (error) {
            setInError(true);
            rollbar.error(error);
        })
            .finally(function () { return setLoading(false); });
    };
    var refreshCardData = function (event) {
        event.preventDefault();
        setIsEmpty(false);
        setInError(false);
        setLoading(true);
        loadCardData();
    };
    var displayErrorOrNoData = function (isEmpty, inError) {
        if (inError) {
            return React.createElement(CardContentError, { refreshCardData: refreshCardData });
        }
        else if (isEmpty) {
            return (React.createElement(Typography, { variant: "body1", component: "div" }, "(None documented)"));
        }
    };
    var errorFallback = function () {
        return React.createElement(CardContentError, { refreshCardData: refreshCardData });
    };
    var card = (React.createElement(FacesheetStyledCard, null,
        React.createElement(Box, null,
            React.createElement(FacesheetCardTitle, { title: React.createElement(Typography, { variant: "h2", color: "primary", component: "div" }, title) })),
        React.createElement(Loader, { condition: !loading },
            React.createElement(FacesheetCardContent, null, isEmpty || inError ? (displayErrorOrNoData(isEmpty, inError)) : (React.createElement(ErrorBoundary, { FallbackComponent: errorFallback, onError: function (error) {
                    rollbar.error(error);
                } },
                React.createElement(CardContentContainer, { type: title, data: cardData, patientId: patientId, patientStatus: patientStatus })))))));
    return (React.createElement(React.Fragment, null, title === CardTypes.Recommendations ? (React.createElement(Box, { position: "relative" }, card)) : (React.createElement(CardActionArea, { href: url }, card))));
};
export default FacesheetCard;
